import {
    otherIndex
} from '@/api/other';

export default {
    namespaced: true,
    state: () => ({
        otherInfo: ''
    }),
    mutations: {
        setOtherInfo(state, obj) {
            state.otherInfo = obj;
        },
    },
    actions: {
        async fetchData({
            commit
        }, {
            hisUid
        }) {
            try {
                const res = await otherIndex({
                    hisUid
                });
                if (res.errno === 0) {
                    commit('setOtherInfo', res.data.info);
                } else {
                    console.error(res.errmsg);
                }
            } catch (error) {
                console.error(error);
            }
        },
    },
};